import React, { Component } from "react";
import DesktopHeader from "../components/DesktopHeader";
import MobileHeader from "../components/MobileHeader";
import "./Contact.css";

class ContactThankYou extends Component {
  render() {

    return (
      <div
        className="contact-container"
        style={{
          height: "100vh",
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          fontFamily: "Raleway",
          overflow: "hidden",
          justifyContent: "center",
        }}
      >
        {window.innerWidth > 768 ? <DesktopHeader /> : <MobileHeader />}
        <div
          className="row"
          style={
            window.innerWidth > 1200
              ? {
                  textAlign:"center",
                  width: "100%",
                  fontFamily: "Raleway",
                  color: "#5C626C",
                  paddingTop: "10%",
                  justifyContent:"center"
                }
              : {
                  alignItems: "center",
                  width: "100%",
                  fontFamily: "Raleway",
                  color: "#5C626C",
                  paddingTop: "5%",
                }
          }
        >
          <div
            style={{
              width: "90%",
              fontFamily: "Raleway",
              color: "#5C626C",
              textAlign: "center",
              justifyContent:"center",
            }}
          >
            <h1 style={{justifyContent:"center"}}>Thanks for your message! We'll be in touch shortly.</h1>
          </div>
       
        </div>
      </div>
    );
  }
}

export default ContactThankYou;
